// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as DateTime$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function getFormattedOrderPickupTime(workUnit) {
  switch (workUnit.TAG | 0) {
    case /* Order */0 :
        return Timestamp$Catalyst.toString(Timestamp$Catalyst.make(workUnit._1.pickupTime * 1000.0), "hh:mm a");
    case /* Login */1 :
        return "09:00 pm";
    case /* Mbg */2 :
        return "10:00 pm";
    
  }
}

function getOrderId(workUnit) {
  switch (workUnit.TAG | 0) {
    case /* Order */0 :
        return workUnit._1.orderId;
    case /* Login */1 :
    case /* Mbg */2 :
        return "";
    
  }
}

function getDropLocation(orderDetails, title) {
  var dropLocality = OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(orderDetails.dropLocality);
  if (dropLocality === "") {
    return title;
  } else {
    return dropLocality + (" " + title);
  }
}

function getEarningTitle(workUnit) {
  switch (workUnit.TAG | 0) {
    case /* Order */0 :
        return getDropLocation(workUnit._1, workUnit._0);
    case /* Login */1 :
    case /* Mbg */2 :
        return workUnit._0;
    
  }
}

function earningTitle(data, workspaceDispatch) {
  var match = data.workUnit;
  switch (match.TAG | 0) {
    case /* Order */0 :
        return {
                TAG: /* Text */0,
                _0: getEarningTitle(data.workUnit)
              };
    case /* Login */1 :
    case /* Mbg */2 :
        break;
    
  }
  return {
          TAG: /* ActionButton */3,
          _0: getEarningTitle(data.workUnit),
          _1: (function (param) {
              return Curry._2(workspaceDispatch.addTab, {
                          TAG: /* OrderDetails */10,
                          _0: getOrderId(data.workUnit),
                          _1: undefined
                        }, false);
            })
        };
}

function getTableColumnsSchema(workspaceDispatch) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Date"
            },
            accessor: (function (data) {
                return {
                        TAG: /* Text */0,
                        _0: DateTime$Catalyst.toString("Do MMMM YY", data.date)
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Earning Time"
              },
              accessor: (function (data) {
                  return {
                          TAG: /* Text */0,
                          _0: getFormattedOrderPickupTime(data.workUnit)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Earning Title"
                },
                accessor: (function (data) {
                    return earningTitle(data, workspaceDispatch);
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Total Earnings"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Text */0,
                              _0: data.totalEarnings.toString()
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Total Cash Settlement"
                    },
                    accessor: (function (data) {
                        return {
                                TAG: /* Text */0,
                                _0: data.totalCashSettlement.toString()
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Total Wallet Settlement"
                      },
                      accessor: (function (data) {
                          return {
                                  TAG: /* Text */0,
                                  _0: data.totalWalletSettlement.toString()
                                };
                        })
                    },
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function WeeklyEarningsDetailsTable(Props) {
  var tableData = Props.tableData;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  return React.createElement("div", {
              className: "table-wrapper"
            }, React.createElement(TableComponent$Catalyst.make, {
                  columns: getTableColumnsSchema(workspaceDispatch),
                  rowData: tableData,
                  className: "customTable"
                }));
}

var make = WeeklyEarningsDetailsTable;

export {
  getFormattedOrderPickupTime ,
  getOrderId ,
  getDropLocation ,
  getEarningTitle ,
  earningTitle ,
  getTableColumnsSchema ,
  make ,
  
}
/* react Not a pure module */
